export const poMode = (mode) => {

  switch (mode) {
    case "RESEND_MAIL":
      return '/po/otp'

    case "VERIFY_OTP":
      return "/po/otp"

    case "CREATE_PASSWORD":
      return "/po/create-password"

    case "BILLINGADDRESS":
      return "/po/billing"

    case "PAYMENT":
      return "/po/pricing"

    case "COLLEGEINFO":
      return "/po/college-info"

    case "COLLEGEADDRESS":
      return "/po/college-address"

    case "CONTACTINFO":
      return "/po/contact-info"

    case "ACADEMICINFO":
      return "/po/college-academic"

    case "DASHBOARD":
      return "/po/home"

    case "CHANGEPASSWORD":
      return "/po/create-password"

    case "PAYMENTEXPIRY":
      return "/po/home"

    default:
      return "/page-not-found"
  }

};
